import { cn } from "@/lib/utils";
interface MatchScoreProps {
  score: number;
  showText?: boolean;
  size?: "sm" | "md" | "lg";
  className?: string;
  running?: boolean;
}
export const MatchScore = ({
  score,
  showText = false,
  size = "md",
  className,
  running = false
}: MatchScoreProps) => {
  const getColorClass = () => {
    if (score <= 40) return "bg-red-500 text-white";
    if (score <= 69) return "bg-orange-500 text-white";
    return "bg-green-600 text-white";
  };
  const getSizeClass = () => {
    switch (size) {
      case "sm":
        return "h-7 w-7 text-[10px]";
      case "lg":
        return "h-10 w-10 text-sm";
      default:
        return "h-8 w-8 text-xs";
    }
  };

  if (running) {
    return <div className={cn("flex items-center", className)}>
      <div className={cn("rounded-sm flex items-center justify-center font-semibold shadow-sm", getSizeClass())}>
        <svg 
          className="animate-spin" 
          xmlns="http://www.w3.org/2000/svg" 
          width="1em" 
          height="1em" 
          viewBox="0 0 24 24"
        >
          <path 
            fill="currentColor" 
            d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 8-8a8 8 0 0 1-8 8z" 
            opacity=".3"
          />
          <path 
            fill="currentColor" 
            d="M20 12h2A10 10 0 0 0 12 2v2a8 8 0 0 1 8 8z"
          />
        </svg>
      </div>
      {showText}
    </div>
  }

  return <div className={cn("flex items-center", className)}>
      <div className={cn("rounded-sm flex items-center justify-center font-bold shadow transition-all duration-300", getColorClass(), getSizeClass())}>
        {score.toFixed(0)}%
      </div>
      {showText}
    </div>;
};
